import { Flex } from 'antd';

import { useSingleGraphReferenceContext } from 'business/providers/graph-reference';
import ReportActivityAnalyzeExportButton from 'business/shift-report/report-analyze/pages/activity-analyze/components/export-button';
import { handlePrintWithChart } from 'technical/handle-print-with-chart';
import { PrintButton } from 'ui/button/print-button';

const ReportActivityAnalyzeHeader = () => {
  const { ref } = useSingleGraphReferenceContext();

  return (
    <Flex gap={4} justify="flex-end" align="center">
      <PrintButton onClick={() => handlePrintWithChart(ref)} />
      <ReportActivityAnalyzeExportButton />
    </Flex>
  );
};

export default ReportActivityAnalyzeHeader;
